import { AuthEntryPoint } from '../../features/auth/types';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { ButtonLocation } from '../../types/Subscriptions';
import { GeneralSubscription } from '../GeneralSubscription';
import { Image } from '../Image';

export const SubscriptionBanner = ({
  buttonLocation,
  image,
  source,
  subtitle,
  title,
}: {
  buttonLocation: ButtonLocation;
  image?: string;
  source: AuthEntryPoint;
  subtitle: string;
  title: string;
}) => {
  const mobile = useMediaQuery('sm');

  return (
    <div className="relative flex gap-0 overflow-hidden rounded-sm border border-divider/20 bg-white max-md:flex-col">
      {image && (
        <div className="relative min-h-72 w-full">
          <Image
            alt={title}
            src={image}
            className="h-full w-full"
            ignoreAspectRatio
          />
        </div>
      )}
      <div className="relative flex w-full flex-col items-center justify-center px-6 py-6 md:py-24">
        <div className="mx-auto flex w-full max-w-md flex-col items-center justify-center gap-6">
          <h2 className="w-full text-balance text-center text-md font-bold md:text-lg">
            {title}
          </h2>
          <p className="w-full text-balance text-center">{subtitle}</p>
          <GeneralSubscription
            analyticsButtonLocation={buttonLocation}
            dark
            inlineInputs={!mobile}
            isFullWidth={mobile}
            legalsDefault
            source={source}
          />
        </div>
      </div>
    </div>
  );
};
